import { Component, effect, input, model, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DownloadStatus } from '@agilox/common';
import { UITheme } from '@agilox/ui-common';
import { ButtonComponent, IconModule, TooltipModule } from '@agilox/ui';

@Component({
	selector: 'download-icon',
	imports: [IconModule, TooltipModule, TranslateModule, ButtonComponent],
	templateUrl: './download-icon.component.html',
})
export class DownloadIconComponent {
	type = input<UITheme | 'link' | 'link-dark'>('link');
	status = model<DownloadStatus | null>(null);
	iconTooltip = input<string>('');

	/** How long the status should be displayed */
	timer = model<number | undefined>(3000);

	iconClicked = output<Event>();

	constructor() {
		effect(() => {
			if (this.status()) {
				this.setTimer();
			}
		});
	}

	setTimer() {
		if (this.timer()) {
			setTimeout(() => {
				this.status.set(null);
			}, this.timer());
		}
	}

	protected readonly DownloadStatus = DownloadStatus;
}
